import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShieldCheck3"><Path fillRule="evenodd" clipRule="evenodd" d="M21 5.34595L12 1.40845L3 5.34595V13C3 17.9705 7.02944 22 12 22C16.9706 22 21 17.9705 21 13V5.34595ZM16.4142 9.99997L15 8.58576L11 12.5858L9 10.5858L7.58579 12L11 15.4142L16.4142 9.99997Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldCheck3;
